// CSS
import calendarCss from "./calendar.css";
import toastCss from "../../styles/toast.css";
import styles from "./style.css";
import i18next from "i18next";
import { EventObject } from "@toast-ui/calendar/*";
import moment from "moment";

const arrow = `
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 292.359 292.359" style="enable-background:new 0 0 292.359 292.359;"
    xml:space="preserve">
<g>  
    <path d="M222.979,5.424C219.364,1.807,215.08,0,210.132,0c-4.949,0-9.233,1.807-12.848,5.424L69.378,133.331
        c-3.615,3.617-5.424,7.898-5.424,12.847c0,4.949,1.809,9.233,5.424,12.847l127.906,127.907c3.614,3.617,7.898,5.428,12.848,5.428
        c4.948,0,9.232-1.811,12.847-5.428c3.617-3.614,5.427-7.898,5.427-12.847V18.271C228.405,13.322,226.596,9.042,222.979,5.424z"/>
</g>
</svg>  
`;

const cross = `
<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" tabindex="0" id="close-icon" >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.00024 5.40694L9.48633 9.29488L9.88915 8.83008L5.46981 4.99998L9.88915 1.16988L9.48633 0.705078L5.00024 4.59302L0.514155 0.705078L0.111328 1.16988L4.53067 4.99998L0.111328 8.83008L0.514155 9.29488L5.00024 5.40694Z" fill="black"/>
</svg>
`;

export const popupSelectEvent = (body: string) => `
<style>
    .square {
        width: 12px;
        height: 12px;
        background-color: var(--square-color,rgb(247, 247, 247));
    }

    .popup-view-wrapper {
        padding: 10px;
        min-width: 400px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .popup-view-header {
        display: flex;
        justify-content: end;
    }

    .popup-view-content {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .popup-view-footer {
        display: flex;
        justify-content: end;
        gap: 10px;
    }

    #close-icon {
        cursor: pointer;
    }

    #edit button {
      color: #fff;
      background: #345AA4;
    }
 
</style>

<div class="popup-content" style="background: #fff;">
    <div class="popup-view-wrapper">
        <div class="popup-view-header">
            ${cross}
        </div>

        <div class="popup-view-content">
            <div class="square"></div>
            <span>${body ?? ""}</span>
        </div>
        
        <div class="popup-view-footer">
            <fw-button id="edit" color="primary"> ${i18next.t($ => $.scheduleBacnet.edit)} </fw-button>
            <fw-button id="delete" color="secondary"> ${i18next.t($ => $.delete)} </fw-button>
        </div>
    </div> 
</div>
`;

export const popupContextMenuCalendar = () => `
<div class="popup-content" style="background: #fff;">
  <ul class="popup-items">
    <li id="add">${i18next.t($ => $.scheduleBacnet.addWeekSchedule)}</li>
    <li id="exclude">${i18next.t($ => $.scheduleBacnet.addException)}</li>
  </ul>
</div>
`;

export const popupContextMenuEvent = (isException: boolean) => `
<style>
  .popup-content_duplicate {
    min-width: 194px;
  }
</style>
<div class="popup-content popup-content_duplicate" style="background: #fff;">
  <ul class="popup-items">
    <li id="edit">${i18next.t($ => $.scheduleBacnet.editEvent)}</li>
    <li id="delete">${i18next.t($ => $.scheduleBacnet.deleteEvent)}</li>
    ${isException ? '' : `<li id="duplicate" class="expandable">${i18next.t($ => $.scheduleBacnet.duplicateEvent)}</li>`}
  </ul>
</div>
`;

export const popupEventsList = (date: Date) => {
  const parsedDate = moment(date);
  return `
    <style>
      .popup-content_event-list {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
      }
      .title {
        padding: 12px;
      }
      .title-date {
        color: #333;
        font-size: 18px;
      }
      .title-day {
        color: #333;
        font-size: 10px;
      }
      .events-list {
        padding: 5px;
        margin: 0;
        list-style-type: none;
        display: flex;
        flex-direction: column;
        gap: 5px;
        min-width: 140px;
        max-height: 200px;
        overflow: auto;
        box-sizing: border-box;
        flex: 1;
      }
      .item {
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
      }
      .item_weekly {
        background-color: #B9C9EC;
      }
      .item_exception {
        background-color: #7827CA4D;
      }
    </style>
    <div class="popup-content popup-content_event-list" style="background: #fff;">
      <div class="title">
        <span class="title-date">${parsedDate.format('DD')}</span>
        <span class="title-day">${parsedDate.format('ddd')}</span>  
      </div>
      <ul class="events-list">

      </ul>
    </div>
  `
}

      // ${events.map(
      //   event => `
      //     <li
      //       data-calendar-id="${event.calendarId}"
      //       data-event-id="${event.id}"
      //     >
      //       ${moment(event.start.d.d).format('hh:mm')}, ${event.body}
      //     </li>`
      // )}

export const popupDuplicateEvent = () => `
<style>
  .popup-content {
    background-color: #fff;
  }
  .popup-duplicate {
    padding: 10px;
  }
  .list {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
  .list li {
    list-style: none;
  }
</style>
<div class="popup-duplicate popup-content">
  <ul class="list">
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.monday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.tuesday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.wednesday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.thursday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.friday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.saturday)}</fw-checkbox>
    </li>
    <li>
      <fw-checkbox>${i18next.t($ => $.scheduleBacnet.sunday)}</fw-checkbox>
    </li>
  </ul>
</div>
`

export const template = () => `
<style>
  ${calendarCss}
</style>
<style>
  ${toastCss}
</style>
<style>
  ${styles}
</style>
<div style="width: 100%" class="calendar-container">
  <div class="calendar-sm-container">
    <div class="calendar-sm-nav">
      <select
          id="calendars-block"
          placeholder="${i18next.t($ => $.scheduleBacnet.schedulesList)}"
          options-variant="icon"
      >
      </select>
    </div>
    <div class="calendar-sm-wrapper">
      <div id="calendar-sm"></div>

      <div class="controls">
        <p>${i18next.t($ => $.scheduleBacnet.weeklySchedule)}</p>
        <div class="controls-row">
          <fw-button id="open-week" color='secondary' style="flex: 1;">${i18next.t($ => $.scheduleBacnet.add)}</fw-button>
          <fw-button id="edit-week" color='secondary' style="flex: 1;">${i18next.t($ => $.scheduleBacnet.edit)}</fw-button> 
        </div>
      </div>

      <div class="controls">
        <p>${i18next.t($ => $.scheduleBacnet.exceptions)}</p>
         
        <div class="controls-row">
          <fw-button id="open-exception" color='secondary' style="flex: 1;">${i18next.t($ => $.scheduleBacnet.add)}</fw-button>
          <fw-button id="edit-exception" color='secondary' style="flex: 1;">${i18next.t($ => $.scheduleBacnet.edit)}</fw-button>
        </div> 
      </div>
    </div>
  </div>
  <div class="calendar-lg-container">
    <div class="calendar-lg-nav">
      <ul id="calendar-view-container">
        <li class="active" view="today">${i18next.t($ => $.scheduleBacnet.today)}</li>
        <li view="day">${i18next.t($ => $.scheduleBacnet.day)}</li>
        <li view="week">${i18next.t($ => $.scheduleBacnet.week)}</li>
        <li view="workweek">${i18next.t($ => $.scheduleBacnet.workWeek)}</li>
        <li view="month">${i18next.t($ => $.scheduleBacnet.month)}</li>
      </ul>
    </div>
    <div class="calendar-main">
      <div class="calendar-header-container">
        <div class="arrow left">
          ${arrow}
        </div>
        <div id="time-header">
          13/13/1322
        </div>
        <div class="arrow right">
          ${arrow}
        </div>
      </div>
      <div id="calendar-lg" style="width: 100%"></div>
    </div>
  </div>
</div>
`;
